export default __webpack_public_path__ + "static/media/twinCities1.965bd38f.webp";